






























































































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwCountryIcon } from '@libs-uuif/shared/sw-country-icon';
import { SwSelect } from '@libs-uuif/shared/sw-select';
import Component from 'vue-class-component';
import { SwModal, SwModalBody, SwModalFooter } from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import RegexValidators from '@/shared/regex-validators';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import { SwForm, SwFormRow,  SwFormRowError } from '@libs-uuif/shared/sw-form';
import { Prop } from 'vue-property-decorator';
import { required } from 'vuelidate/lib/validators';

const cssPrefix = 'renewal-contact';
@Component({
  components: {
    SwCountryIcon,
    SwSelect,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
    SwTextfield,
    SwCheckbox,
    SwForm,
    SwFormRow,
    SwFormRowError,
  },
  validations: {
    fname: { required },
    lname: { required },
    email: { required },
  },
})
export default class RenewalContact extends SwExtendedVue {
  cssPrefix = cssPrefix;
  display2 = true;
  modalTitle = '';
  fname: any = '';
  lname : any = '';
  email : any = '';
  emailValidator = new RegExp(RegexValidators.email);
  duplicateRenewalInfo : boolean = false;
  duplicateRenewalInfo2 : boolean = false;
  duplicateRenewalMessage : any = '';
  @Prop({ required :  true })
  renewalRows : any;
  @Prop({ required :  true })
  emailAddress : any;
  created() {
  }
  closeDialog() {
    this.$emit('close-modal');
  }
  submit() {
    this.duplicateRenewalInfo =  false;
    this.duplicateRenewalInfo2 = false;
    if (this.checkInputValidation()) {
      if (this.renewalRows.filter((item : any) => JSON.stringify(item.emailAddress) === JSON.stringify(this.email)).length <= 0) {
        this.$store.commit('startLoading');
        this.$store.dispatch('SnbProfileStoreModule/validateRenewalContact', this.email)
        .then((resp) => {
          if (resp.operationStatus !== 'OK') {
            this.duplicateRenewalInfo2 = true;
            this.duplicateRenewalMessage = resp.msgDesc;
            this.$store.commit('stopLoading');
            return;
          }
          const request = {
            renewalcontact : {
              firstName: this.fname,
              lastName: this.lname,
              emailAddress: this.email,
              contactId: '',
            },
            adminEmail : this.emailAddress,
          };
          this.$store.dispatch('SnbProfileStoreModule/createRenewalContact', request)
          .then((resp) => {
            if (resp.operationStatus === 'OK') {
              this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
              request.renewalcontact.contactId = resp.content.renewalContactID;
              this.$emit('success', request);
            } else {
              this.$emit('failed', resp);
            }
          });
        });
      } else {
        this.duplicateRenewalInfo = true;
      }
    }
  }

  checkInputValidation(): boolean {
    this.$v!.fname!.$touch();
    this.$v!.lname!.$touch();
    this.$v!.email!.$touch();
    if (!this.$v!.fname!.$invalid && !this.$v!.lname!.$invalid &&
        !this.$v!.email!.$invalid &&
        (this.fname != null && this.fname !== '') &&
        (this.lname != null && this.lname !== '') &&
        (this.email !== null && this.email !== '')) {
      return true;
    }
    return false;
  }

  cancel() {
    this.$emit('close-modal');
  }
  onEmailInput() {
  }
}
